import store from '~/store'
import i18n from '~/plugins/i18n'
import {isPos} from "../plugins/config";
import {hasPermissionByRouteName} from "../router/permissions";

export default (to, from, next) => {
    const fromRouteName = from.name
    if (hasPermissionByRouteName(to.name)) next()
    else next({name: fromRouteName??'home'})
}
